module.exports = __webpack_public_path__ + "assets/43d47e3a01d8491c5f4f886bcbf00873.svg";